module.exports = __webpack_public_path__ + "img/login_flowing_button.d1b3fa16.svg";